import React, { useEffect } from "react";
import styled from "styled-components";
import AOS from "aos";
import { FaLightbulb } from "react-icons/fa";
import { FaSearch } from "react-icons/fa";
import { FaShieldAlt } from "react-icons/fa";
import { FaCompassDrafting, FaEye, FaHandshakeSimple } from "react-icons/fa6";

function AboutSecondPhase() {
  useEffect(() => {
    AOS.init({
      duration: 1200,
    });
  }, []);

  return (
    <Container>
      <h1 className="shine" data-aos="fade-up">
        Our Values
      </h1>

      <Wrap>
        <Left>
          <Slot data-aos="fade-up">
            <Background className="bg" />
            <Head>
              <FaLightbulb className="icon_about" />
              <h2>Creativity</h2>
            </Head>
            <Body>
              <p>
                We always make best videos by magical process of transforming
                your vision into reality through creativity.
              </p>
            </Body>
          </Slot>

          <Slot data-aos="fade-up">
            <Background className="bg" />
            <Head>
              <FaSearch className="icon_about" />
              <h2>Transparency</h2>
            </Head>
            <Body>
              <p>
                We find it highly valuable that we open to suggestions from our
                clients and never hesitate to speak our mind about the best way
                of making videos.
              </p>
            </Body>
          </Slot>

          <Slot data-aos="fade-up">
            <Background className="bg" />
            <Head>
              <FaShieldAlt className="icon_about" />
              <h2>Uniqueness</h2>
            </Head>
            <Body>
              <p>
                We provide customized & unique video ideas/ content to reach to
                your target audience by fulfilling your exact requirement.
              </p>
            </Body>
          </Slot>
        </Left>

        <Right>
          <Slot data-aos="fade-up">
            <Background className="bg" />
            <Head>
              <FaCompassDrafting className="icon_about" />
              <h2>Ambition</h2>
            </Head>
            <Body>
              <p>
                We strive to exceed each client’s expectations with highly
                proactive and ‘can-do’ mentality to achieve the end goal.
              </p>
            </Body>
          </Slot>

          <Slot data-aos="fade-up">
            <Background className="bg" />
            <Head>
              <FaEye className="icon_about" />
              <h2>Expertise</h2>
            </Head>
            <Body>
              <p>
                We have passionate, experienced, and goal-oriented team to make
                creative & eye-catching video productions with years of
                experience in the industry.
              </p>
            </Body>
          </Slot>

          <Slot data-aos="fade-up">
            <Background className="bg" />
            <Head>
              <FaHandshakeSimple className="icon_about" />
              <h2>Responsibility</h2>
            </Head>
            <Body>
              <p>
                We all are accountable for our relevant duties and responsible
                video production company to give you the best service.
              </p>
            </Body>
          </Slot>
        </Right>
      </Wrap>
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
  min-height: 50vh;
  padding-bottom: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: var(--primary-color);

  h1 {
    font-size: 48px;
    text-transform: uppercase;
    text-align: center;
    margin: 80px 0;

    @media only screen and (max-width: 1024px) {
      font-size: 32px;
      margin: 50px 0;
    }

    @media only screen and (max-width: 768px) {
      font-size: 25px;
      margin: 30px 0;
    }
  }
`;

const Wrap = styled.div`
  width: 80%;
  display: flex;

  @media only screen and (max-width: 1024px) {
    width: 90%;
  }

  @media only screen and (max-width: 768px) {
    width: 97%;
    flex-direction: column;
  }
`;

const Left = styled.div`
  width: 50%;
  padding: 0 20px;

  @media only screen and (max-width: 1024px) {
    width: 100%;
    padding: 0 15px;
  }

  @media only screen and (max-width: 768px) {
    width: 100%;
  }
`;

const Right = styled.div`
  width: 50%;
  padding: 0 20px;

  @media only screen and (max-width: 1024px) {
    width: 100%;
    padding: 0 15px;
  }

  @media only screen and (max-width: 768px) {
    width: 100%;
  }
`;

const Slot = styled.div`
  width: 95%;
  color: #fff;
  height: 160px;
  padding: 10px 20px;
  position: relative;
  margin-bottom: 20px;
  overflow: hidden;
  border-radius: 28px;
  background-color: #121212;
  cursor: pointer;
  z-index: 1;

  &:hover .bg {
    transform: scale(15);
    opacity: 1;
  }

  @media only screen and (max-width: 1024px) {
    height: 140px;
    padding: 10px 15px;
  }

  @media only screen and (max-width: 768px) {
    height: 120px;
  }
`;

const Background = styled.div`
  height: 100px;
  width: 100px;
  background-image: linear-gradient(to left bottom, #058789, #068082, #08797a, #087273, #096b6c, #096167, #0f5660, #144c58, #1d3c49, #202c37, #1c1e24, #121212);
  position: absolute;
  top: -40px;
  right: -40px;
  border-radius: 50%;
  z-index: 0;
  transition: transform 0.5s ease, opacity 0.5s ease;
  transform: scale(1);
  opacity: 0.7;
`;

const Head = styled.div`
  width: 100%;
  height: 40%;
  display: flex;
  z-index: 2;
  position: relative;
  border-bottom: 1px solid var(--secondary-color);

  .icon_about {
    font-size: 25px;
    margin-top: 10px;
    color: var(--secondary-color);

    @media only screen and (max-width: 1024px) {
      font-size: 20px;
    }
  }

  h2 {
    margin: 10px 10px;
    font-size: 24px;
    font-weight: 600;
    letter-spacing: 1.1px;
    z-index: 2;
    position: relative;
    transition: color 0.5s ease;

    @media only screen and (max-width: 1024px) {
      font-size: 20px;
    }

    @media only screen and (max-width: 768px) {
      font-size: 18px;
    }
  }
`;

const Body = styled.div`
  width: 100%;
  height: 60%;
  z-index: 2;
  position: relative;

  p {
    margin: 10px 0;
    font-size: 14.5px;
    z-index: 2;
    position: relative;
    transition: color 0.5s ease;

    @media only screen and (max-width: 1024px) {
      font-size: 13.5px;
    }

    @media only screen and (max-width: 768px) {
      font-size: 13px;
    }
  }
`;

export default AboutSecondPhase;
